import { queryOptions } from '@tanstack/react-query'
import { authClient } from './auth-client'
import { queryClient } from './query-client'

export const queryKeys = {
  getSession: ['session'],
}

/**
 * Get currently logged in user session
 */
export const getSessionQueryOptions = () =>
  queryOptions({
    queryKey: queryKeys.getSession,
    queryFn: () => authClient.getSession(),
    staleTime: 3 * 60 * 1000, // 3 minutes
  })

/**
 * Invalidates the fetched user session data in the React Query cache, usually called after logging out
 */
export const invalidateSessionQuery = () => {
  queryClient.invalidateQueries({ queryKey: queryKeys.getSession })
}
